<script>
export default {
    props: {
        cardNumber: {
            type: String,
            required: true
        },
        email: String,
        name: String,
    },
    data() {
        return {
            result: {},
            checkDone: false,
            errorMsg: null,
        }
    },
    methods: {
        close() {
            this.$emit('remove');
        },
        setErrorMessage(msg) {
            if (msg instanceof Promise) {
                msg.then( errText => this.setErrorMessage(errText) );
            } else {
                this.errorMsg = msg;
                this.checkDone = true;
            }
        }
    },
    mounted() {
        const formData = new FormData();

        formData.append('member', this.cardNumber);
        formData.append('name', this.name || '');
        formData.append('email', this.email || '');

        fetch('https://tracker.aopa.ru/api/members/verifyMember', {
            method: 'post',
            body: formData,
            credentials: 'include',
        }).then(response => { 
            if (response.ok) {
                 return response.json();
            } else { 
                throw response.text();
            }
        }).then(result => {
            this.result = result;
            this.checkDone = true
        }).catch(msg => this.setErrorMessage(msg));
    }
}
</script>

<template>
    <div class="alert alert-info">
        <button type="button" class="close" aria-hidden="true" @click.prevent="close">×</button>
        <p>Номер карты: {{ cardNumber }}<template v-if="checkDone && result.status">&nbsp;<span v-if="1 === result.status" class="label label-success">действительна</span><span v-if="3 === result.status" class="label label-warning">недействительна</span></template></p>
        <p v-if="checkDone && result.expires">Действительна до: {{ result.expires }}</p>
        <p v-if="email">Email: {{ email }}</p>
        <p v-if="name">ФИО: {{ name }}</p>
        <p v-if="!checkDone"><i class="fas fa-spinner fa-spin"></i> Запрос данных</p>
        <p v-if="checkDone && result.name">Имя на карте: {{ result.name }}</p>
        <span class="badge badge-warning" v-if="checkDone && errorMsg">Ошибка: {{ errorMsg }}</span>
    </div>
</template>
